module.exports = __webpack_public_path__ + "img/hr-electric-mining-drill-N-drill-shadow.ba3d49f3.png";